<template>
  <section>
    <div class="container" id="SignInPage">
      <div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" style="background-color: #fff100">
              <h5 class="modal-title" id="staticBackdropLabel"><b>Register</b></h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="color: #000"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="register">
                <div class="mt-3">
                  <label>First Name</label>
                  <input type="text" class="form-control" name="firstname" placeholder="First Name" required v-model="firstName">
                </div>
                <div class="mt-3">
                  <label>Middle Name</label>
                  <input type="text" class="form-control" name="firstname" placeholder="Middle Name" required v-model="middleName">
                </div>
                <div class="mt-3">
                  <label>Last Name</label>
                  <input type="text" class="form-control" name="firstname" placeholder="Last Name" required v-model="lastName">
                </div>
                <div class="mt-3">
                  <label>Mobile Name</label>
                  <input type="text" class="form-control" minlength="10" maxlength="10" placeholder="Mobile Number" pattern="[0-9]*" name="contact" required v-model="mobileNumber">
                </div>
                <div class="mt-3">
                  <label>Assembly</label>
                  <select class="form-control" v-model="assembly">
                    <option value="131-Boisar">131-Boisar</option>
                    <option value="132-Nalasopara">132-Nalasopara</option>
                    <option value="133-Nalasopara">133-Vasai</option>
                  </select>
                </div>
                <div class="mt-3">
                  <label>Ward No</label>
                  <input type="text" class="form-control"  v-model="wardNo">
                </div>
                <div class="mt-3">
                  <label>Address</label>
                  <textarea class="form-control" v-model="address" required></textarea>
                </div>
                <button class="btn btn-primary mt-3 mb-3" style="background-color: #2e3a9e">
                  Register
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex flex-row align-items-center justify-content-center" style="margin-top: 20px">
        <div class="col-md-6">
          <!-- Error message display -->
          <p class="text-center text-danger" v-if="errMsg">{{ errMsg }}</p>
          <div class="row align-items-center justify-content-center">
            <div class="col-md-6">
              <div class="column align-items-center justify-content-center">
                <!-- Mobile Number Input -->
                <div class="mb-3">
                  <label for="mobileNumber"><b>Mobile Number</b></label>
                  <input
                    type="tel"
                    id="mobileNumber"
                    class="form-control"
                    name="mobileNumber"
                    placeholder="Enter your mobile number"
                    minlength="10"
                    v-model="number"
                    required
                  />
                </div>

                <div class="mb-3" v-if="!isValid">
                  <div class="g-recaptcha" :data-sitekey="siteKey" data-callback="onCaptchaVerified"></div>
                  <button class="btn btn-primary w-100 mt-3" :disabled="loading" style="background-color: #2e3a9e" @click="generateOTP">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    Generate OTP
                  </button>
                </div>

                <!-- OTP Input -->
                <div class="mb-3" v-if="isValid">
                  <label for="otp"><b>OTP</b></label>
                  <input
                    type="text"
                    id="otp"
                    class="form-control"
                    name="otp"
                    placeholder="Enter the OTP"
                    minlength="6"
                    v-model="otp"
                    required
                  />
                </div>

                <div class="mb-3" v-if="isValid">
                  <button class="btn btn-primary w-100" :disabled="loading" style="background-color: #2e3a9e" @click="signIn">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    Sign In
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import axios from 'axios';

export default {
  name: 'SignInPage',
  data() {
    return {
      siteKey: '6LfpGm4qAAAAAIj_HE0XboNrFMXNAGY1SNNd0Urm',
      number: '', // to bind mobile number input
      otp: '', // to bind OTP input
      isValid: false,
      loading: false, // to manage loading state
      errMsg: null, // to hold error messages
      recaptchaToken: null,
      firstName: null,
      middleName: null,
      lastName: null,
      address: null,
      mobileNumber: null,
      modalInstance: null,
      wardNo: null,
      assembly: null
    };
  },
  mounted() {
    const modalElement = document.getElementById('staticBackdrop1');
    if (modalElement) {
      this.modalInstance = new window.bootstrap.Modal(modalElement);
    }
  },
  methods: {
    generateOTP() {
      const token = localStorage.getItem("recaptca")
      if(token){
        this.loading = true;
        axios({
          method: "POST",
          url: '/api/v1/auth/sign-in',
          data: {
            number: this.number,
            recaptchaToken: token
          }
        }).then((response) => {
          if(response.data.errCode == -1){
            this.isValid = true
            this.loading = false
          }
          else{
            this.errMsg = response.data.errMsg
            this.loading = false
          }
        }).catch(() => {
          this.errMsg = "Server Error"
        })
      }
      else{
        this.errMsg = "Please complete the reCAPTCHA"
      }
    },
    signIn() {
      this.loading = true;
      axios({
        method: "POST",
        url: '/api/v1/auth/validate',
        data: {
          number: this.number,
          otp: this.otp
        }
      }).then((response) => {
        if(response.data.errCode == -1){
          this.$router.push({ name: 'HomePage' });
          localStorage.setItem("token", response.data.token)
          this.loading = false
        }
        else{
          this.errMsg = response.data.errMsg
          this.loading = false
        }
      }).catch(() => {
        this.errMsg = "Server Error"
        this.loading = false
      })
    },
    register() {
      this.loading = true;
      axios({
        method: "POST",
        url: '/api/v1/auth/register',
        data: {
          firstName: this.firstName,
          middleName: this.middleName,
          lastName: this.lastName,
          address: this.address,
          number: this.mobileNumber,
          assembly: this.assembly,
          wardNo: this.wardNo,
          otp: this.otp
        }
      }).then((response) => {
        if(response.data.errCode == -1){
          this.loading = false
          this.firstName = ""
          this.middleName = ""
          this.lastName = ""
          this.mobileNumber = ""
          this.address = ""
          this.assembly = ""
          this.wardNo = ""
          this.modalInstance.hide()
        }
        else{
          this.errMsg = response.data.errMsg
          this.loading = false
          this.firstName = ""
          this.middleName = ""
          this.lastName = ""
          this.mobileNumber = ""
          this.address = ""
          this.assembly = ""
          this.wardNo = ""
          this.modalInstance.hide()
        }
      }).catch(() => {
        this.errMsg = "Server Error"
        this.firstName = ""
        this.middleName = ""
        this.lastName = ""
        this.mobileNumber = ""
        this.address = ""
          this.assembly = ""
          this.wardNo = ""
        this.modalInstance.hide()
      })
    }
  },
};
</script>

<style>
</style>